import { render, staticRenderFns } from "./coeffcountry.vue?vue&type=template&id=245fe706&"
import script from "./coeffcountry.vue?vue&type=script&lang=js&"
export * from "./coeffcountry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports